import { computeParcelFromCart } from "./computeParcelFromCart";

/** Parse order Items cell: `Name (ID: HOM001) × 2 @ ₹…` separated by ` | `. */
export function parseOrderItemsLine(itemsText) {
  const lines = [];
  for (const part of String(itemsText || "").split(/\s*\|\s*/)) {
    const trimmed = part.trim();
    if (!trimmed) continue;
    const match = trimmed.match(/\(ID:\s*([^)]+)\)\s*×\s*(\d+)/i);
    if (!match) continue;
    lines.push({
      id: match[1].trim(),
      quantity: Math.max(1, Number.parseInt(match[2], 10) || 1),
    });
  }
  return lines;
}

export function buildCartLinesFromOrderItems(itemsText, products) {
  const parsed = parseOrderItemsLine(itemsText);
  if (!parsed.length) return [];
  const byId = new Map(
    (products || []).map((product) => [String(product.id), product]),
  );
  return parsed.map(({ id, quantity }) => {
    const product = byId.get(String(id));
    if (!product) return { id, quantity };
    return { ...product, quantity };
  });
}

/**
 * Shiprocket parcel for an admin order row — dimensions/weight from line items.
 */
export function parcelFromOrder(order, baseParcel, products) {
  const paymentMethodRaw = String(
    order?.paymentmethod ||
      order?.["payment method"] ||
      baseParcel?.paymentMethod ||
      "Prepaid",
  )
    .trim()
    .toUpperCase();
  const paymentMethod = paymentMethodRaw === "COD" ? "COD" : "Prepaid";

  const itemsText = order?.items != null ? String(order.items) : "";

  const cart = buildCartLinesFromOrderItems(itemsText, products);
  const computed = computeParcelFromCart(cart, paymentMethod);

  return {
    ...baseParcel,
    paymentMethod,
    length: computed.length,
    breadth: computed.breadth,
    height: computed.height,
    weight: computed.weight,
  };
}
